export default {
  id: 'slack_promote_jobs',
  title: 'Promote jobs',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_JOBS' ],
  description: 'Send up to 4 selected jobs to your employees so they can easily share them across their network.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_INTRODUCTION_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'blocks',
        key: 'BLOCK_JOB',
      },
      {
        text: {
          text: '[[INPUT_END_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      }
    ]
  },
  blocks: {
    BLOCK_JOB: [
      {
        text: {
          text: '*{{JOB_[ID]_TITLE}}*',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'actions',
        elements: [
          {
            url: '{{JOB_[ID]_LINKEDIN_SHARE_LINK}}',
            text: {
              text: 'LinkedIn',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_[ID]_FACEBOOK_SHARE_LINK}}',
            text: {
              text: 'Facebook',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_[ID]_WHATSAPP_SHARE_LINK}}',
            text: {
              text: 'Whatsapp',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_[ID]_TWITTER_SHARE_LINK}}',
            text: {
              text: 'Twitter',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_[ID]_MESSENGER_SHARE_LINK}}',
            text: {
              text: 'Messenger',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          }
        ]
      }
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following jobs with your network to win rewards! ...',
      defaultValue: 'Share the following jobs with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text at the end',
      placeholder: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}...',
      defaultValue: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/promoteJobs.js